import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function Summarize(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M3 13h18v-2H3v2zm0 6h12v-2H3v2zM3 5v2h18V5H3z" />
    </SvgIcon>
  )
}
